import { createReducer } from '../utils/helpers';
import { ActionTypes } from '../utils/constants';

export const personalizationState = {
  data: null,
  isLoading: false,
  additional: null,
  isReady: false,
  gometa: {
    id: null,
    isLoading: false,
    data: null,
    isReady: false
  },
  coupon: {
    isLoading: false,
    isValid: false,
    coupon: null,
    isReady: false,
    data: null
  },
  submittedCouponForm: false,
};

export default {
  personalization: createReducer(personalizationState, {
    [ActionTypes.REQUEST_CLIENT_INFO](state, action) {
      return {
        ...state,
        gometa: {
          ...state.gometa,
          id: action.payload.id,
          isLoading: true,
          isReady: false,
        }
      }
    },
    [ActionTypes.REQUEST_CLIENT_SUCCESS](state, action) {
      return {
        ...state,
        gometa: {
          ...state.gometa,
          isLoading: false,
          isReady: true,
          data: action.payload?.model
        }
      }
    },
    [ActionTypes.REQUEST_CLIENT_FAILURE](state) {
      return {
        ...state,
        gometa: {
          ...state.gometa,
          isLoading: false,
          isReady: true,
          data: null
        }
      }
    },
    [ActionTypes.FETCH_VERSION_COLOR_INFO_REQUEST](state) {
      return {
        ...state,
        data: null,
        additional: null,
        isLoading: true,
      };
    },
    [ActionTypes.FETCH_VERSION_COLOR_INFO_SUCCESS](state, action) {
      const { data, additional } = action.payload;
      if (!data || !data?.codigo) {
        return {
          ...state,
          data: null,
          isLoading: false,
          additional: null,
        };
      }
      const parsedAdditional = {
        ...additional,
        bancos: [].concat(
          ...Object.keys(additional.bancos).map(bank => [
            additional.bancos[bank],
          ])
        ),
      };

      return {
        ...state,
        data: {
          ...data,
          insurances: data.insurances.map(insurance => ({
            ...insurance,
            characteristics: Object.keys(insurance)
              .filter(key => key.includes('caracteristica') && !!insurance[key])
              .map(key => ({
                id: key.replace('caracteristica', ''),
                text: insurance[key],
              })),
          })),
        },
        isLoading: false,
        additional: parsedAdditional,
        isReady: true,
        coupon: {
          isLoading: false,
          isValid: false,
          coupon: null,
          isReady: false,
          data: null
        }
      };
    },
    [ActionTypes.FETCH_VERSION_COLOR_INFO_FAILURE](state) {
      return {
        ...state,
        isLoading: false,
      };
    },
    [ActionTypes.SELECT_ACCESSORY_REQUEST](state, action) {
      const { accessory } = action.payload;
      const accessoryId = accessory?.id;
      const accesoriosSeleccionados = state.data.accesoriosSeleccionados || [];
      return {
        ...state,
        data: {
          ...state.data,
          accessories: {
            ...Object.keys(state.data?.accessories).reduce((acc, curr) => {
              return {
                ...acc,
                [curr]: state.data?.accessories[curr]?.map(
                  accessory => {
                    if (accessory.id === accessoryId) {
                      return { ...accessory, isSelected: !accessory.isSelected };
                    }
                    return accessory;
                  }
                )
              }
            }, {}),
          },
          accesoriosSeleccionados: accesoriosSeleccionados?.some(
            accessory => accessory.id === accessoryId
          )
            ? accesoriosSeleccionados?.filter(
                accessory => accessory.id !== accessoryId
              )
            : [...accesoriosSeleccionados, accessory],
        },
      };
    },
    [ActionTypes.SELECT_MAINTENANCE_REQUEST](state, action) {
      const { maintenanceId } = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          maintenances: (state.data?.maintenances || []).map(maintenance => {
            if (maintenanceId === maintenance.id) {
              return {
                ...maintenance,
                selected: !maintenance.selected,
              };
            }
            return { ...maintenance, selected: false };
          }),
        },
      };
    },
    [ActionTypes.CHOOSE_INSURANCE_REQUEST](state, action) {
      const { insurance } = action.payload;
      const insuranceIsSelected = (state.data?.segurosSeleccionados || []).some(
        currentInsurance => currentInsurance.id === insurance.id
      );
      return {
        ...state,
        data: {
          ...state.data,
          insurances: state.data.insurances.map(currentInsurance => {
            if (currentInsurance.id === insurance.id) {
              return {
                ...currentInsurance,
                selected: !currentInsurance.selected,
              };
            }
            return { ...currentInsurance, selected: false };
          }),
          segurosSeleccionados: insuranceIsSelected ? [] : [insurance],
        },
      };
    },
    [ActionTypes.CHANGE_PRIME_PERCENTAGE_REQUEST](state, action) {
      const { percentage } = action.payload;
      return {
        ...state,
        additional: { ...state.additional, prima: percentage },
      };
    },
    [ActionTypes.CHANGE_PLAZO_REQUEST](state, action) {
      const { plazo } = action.payload;
      return {
        ...state,
        additional: { ...state.additional, plazo },
      };
    },
    [ActionTypes.CHOOSE_FINANCING_OPTION_REQUEST](state, action) {
      const { option } = action.payload;
      const bancos = state.additional?.bancos || [];
      return {
        ...state,
        additional: {
          ...state.additional,
          bancos: bancos.map(banco => {
            if (banco.post_type === option.post_type) {
              return { ...banco, isSelected: !banco.isSelected };
            }
            return banco;
          }),
        },
      };
    },
    [ActionTypes.REQUEST_COUPON](state, action) {
      return {
          ...state,
          coupon: {
            ...state.coupon,
            isLoading: true,
            coupon: action.payload.coupon,
            isValid: false,
            isReady: false,
            data: null
          }
        }
      },
    [ActionTypes.REQUEST_COUPON_SUCCESS](state, action) {
      const coupon = action.payload.coupon;
      return {
        ...state,
        data: {
          ...state.data,
          descuentoAplicado: !!coupon,
        },
        coupon: {
            ...state.coupon,
            isReady: true,
            isLoading: false,
            isValid: !!coupon,
            data: coupon
        }
      }
    },
    [ActionTypes.RESET_COUPON_SUCCESS](state) {
      return {
        ...state,
        data: {
          ...state.data,
          descuentoAplicado: false,
        },
        coupon: {
          isLoading: false,
          isValid: false,
          coupon: null,
          isReady: false,
          data: null
        }
      }
    },
    [ActionTypes.SEND_COUPON_REQUEST](state) {
      return {
        ...state,
        submittedCouponForm: true,
      }
    },
    [ActionTypes.SET_DESCUENTO_WEB](state, action) {
      return {
        ...state,
        data: {
          ...state.data,
          descuentoWebAplicado: true,
        }
      }
    }
  }),
};
